import { render, staticRenderFns } from "./abandoned.vue?vue&type=template&id=695ab605&"
import script from "./abandoned.vue?vue&type=script&lang=js&"
export * from "./abandoned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports